module.exports = __webpack_public_path__ + "img/kp.528b574e.png";